import { forwardRef, MouseEvent } from "react";

import { BaseInput, BaseInputProps } from "./base";
import { IconName } from "../icon";

export type SearchInputProps = Omit<
  BaseInputProps,
  "leftIcon" | "rightButtonIcon" | "onRightButtonClick"
> & {
  onClear: (event: MouseEvent<HTMLButtonElement>) => void;
  leftIcon?: IconName | null;
};

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (props, ref) => {
    const { onClear, leftIcon = "regularMagnifyingGlass", ...rest } = props;
    return (
      <BaseInput
        ref={ref}
        {...rest}
        leftIcon={leftIcon === null ? undefined : leftIcon}
        rightButtonIcon={props.value ? "regularXmark" : undefined}
        onRightButtonClick={onClear}
      />
    );
  },
);
